import TabToggle from 'components/commons/tab-toogle'
import { Button, Checkbox, InlineError, Input, Spinner } from 'avo-ui'
import UploadImage from 'components/commons/upload-image'
import TextEditor from 'components/commons/text-editor'
import { capitalize } from 'utils/utils'

export const MaintenancePage = ({
    maintenancePageDetail,
    errorForm,
    onChangeForm,
    isLoading,
    isUpdating,
    isLoadingUpload,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-6 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <TabToggle
                        title={'General'}
                        content={
                            <div className={'flex space-x-16'}>
                                <div
                                    className={`w-1/3 ${(maintenancePageDetail?.image_url?.base64 || maintenancePageDetail?.image_url) && 'space-y-3'}`}
                                >
                                    <div className={'font-semibold text-blue-90 required'}>Image</div>
                                    <UploadImage
                                        className={'w-fit'}
                                        classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                        id={'image-title'}
                                        value={
                                            maintenancePageDetail?.image_url?.base64 || maintenancePageDetail?.image_url
                                        }
                                        onChange={(value) => onChangeForm({ name: 'image_url', value })}
                                    />
                                    <InlineError className='mt-2' message={errorForm?.image_url} />
                                </div>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Title</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'title'}
                                            placeholder={'Masukkan title'}
                                            value={maintenancePageDetail?.title}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.title} />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Description</div>
                                        <div className={'flex-1 space-y-3'}>
                                            <TextEditor
                                                className={'!h-fit'}
                                                defaultValue={maintenancePageDetail?.description || '<p></p>'}
                                                onChange={(value) => onChangeForm({ name: 'description', value })}
                                                placeholder={'Isi uraian deskripsi'}
                                            />
                                            <InlineError message={errorForm?.description} />
                                        </div>
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90'}>Platform</div>
                                        {maintenancePageDetail?.platform_status?.map((item, index) => (
                                            <Checkbox
                                                key={index}
                                                label={capitalize(item?.name?.replace('-', ' '))}
                                                name={item?.name}
                                                checked={!!item?.value}
                                                value={!!item?.value}
                                                onChange={onChangeForm}
                                            />
                                        ))}
                                        <InlineError message={errorForm?.platform_status} />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isUpdating}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
